import { Route, Routes } from "react-router-dom";
import VendorStaffCreateScreen from "screens/App/CRM/VendorStaff/VendorStaffCreateScreen";
import VendorStaffDetailScreen from "screens/App/CRM/VendorStaff/VendorStaffDetailScreen";
import VendorStaffEditScreen from "screens/App/CRM/VendorStaff/VendorStaffEditScreen";
import VendorStaffListScreen from "screens/App/CRM/VendorStaff/VendorStaffListScreen";


import { NotFoundScreen } from "screens/NotFoundScreen";

const VendorStaffRouter = () => {
  return (
    <Routes>
      <Route path="/create" element={<VendorStaffCreateScreen />} />
      <Route path="/:id/detail" element={<VendorStaffDetailScreen />} />
      <Route path=":id/edit" element={<VendorStaffEditScreen />} />
      <Route path="/list" element={<VendorStaffListScreen />} />
      <Route path="*" element={<NotFoundScreen />} />
    </Routes>
  );
};

export default VendorStaffRouter;
